export default __webpack_public_path__ + "static/bentoSectionBg-2abd8b51d829a5c37964e23c23e9d6ce.png";